<script setup lang="ts">
import type { PriceZone } from '../types'

defineProps<{
  zone: PriceZone
}>()

defineEmits<{
  change: [zone: PriceZone]
}>()

const ZONES: { value: PriceZone; label: string; aria: string }[] = [
  { value: 'DK1', label: 'Vest', aria: 'Vestdanmark, prisområde DK1' },
  { value: 'DK2', label: 'Øst', aria: 'Østdanmark, prisområde DK2' },
]
</script>

<template>
  <div class="zone-toggle" role="radiogroup" aria-label="Vælg prisområde">
    <button
      v-for="option in ZONES"
      :key="option.value"
      type="button"
      class="zone-toggle__option"
      :class="{ 'zone-toggle__option--active': zone === option.value }"
      role="radio"
      :aria-checked="zone === option.value"
      :aria-label="option.aria"
      @click="$emit('change', option.value)"
    >
      {{ option.label }}
    </button>
  </div>
</template>

<style lang="scss" scoped>
.zone-toggle {
  display: inline-flex;
  padding: 4px;
  background: color('gray-100');
  border: 1px solid color('gray-200');
  border-radius: $radius-pill;
  gap: 2px;

  &__option {
    min-width: 56px;
    min-height: 36px;
    padding: space(1) space(4);
    background: transparent;
    border: none;
    border-radius: $radius-pill;
    color: color('ink');
    font-weight: $font-weight-semibold;
    font-size: $font-size-sm;
    cursor: pointer;
    transition:
      background $duration-base $easing-standard,
      color $duration-base $easing-standard;

    &:hover:not(.zone-toggle__option--active) {
      background: color('gray-200');
    }

    &:focus-visible {
      outline: 2px solid color('accent');
      outline-offset: 2px;
    }

    &--active {
      background: color('primary');
      color: color('white');
      box-shadow: $shadow-sm;
    }
  }
}
</style>
